import { AppShell } from '@/components/AppShell/AppShell';
import styles from './ThankYou.module.css';

export function NotFound() {
  return (
    <AppShell variant="logo-only">
      <main className={styles.wrap}>
        <div className={styles.notFoundCard}>
          <h1 className={styles.heroTitle}>
            <i
              className={`ph-bold ph-waveform ${styles.heroTitleIcon}`}
              aria-hidden="true"
            />{' '}
            Voice Studio
          </h1>
          <p className={styles.notFoundLead}>
            No project ID found in the URL.
          </p>
        </div>
      </main>
    </AppShell>
  );
}
